module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/contract.7ab6266e.svg";